/**
 * Secoia Warranty - Cart Add/Remove Handlers
 * Handles adding and removing Secoia warranty products in the cart
 * Supports: secoia (1 year) and secoia2ans (2 years)
 * 
 * v13
 * 
 * Changes from v12:
 * - Use key-based cart updates (id) instead of line-based where possible (matches new cart.js gwpremove pattern)
 * - Preserve _added_from_pdp, SKU, Barcode, _item_token, and bundle properties on parent updates
 * - isWarrantyProduct now also excludes _added_from_pdp items
 * - updateCartItemByKey utility for more reliable updates when lines shift
 * - Compatibility with new toggleAddOnButtons ($viewCartButtons)
 * 
 */

(function() {
  'use strict';


  // CONFIGURATION - Matches Liquid template

  
  var CONFIG = {
    secoia: {
      propPrefix: '_secoia',
      // Matches: class="apl-section-cart-secoia-add-remove"
      addButtonClass: '.apl-section-cart-secoia-add-remove',
      // Matches: data-typeofbutton="secoiaremove"
      removeButtonSelector: 'cart-remove-button[data-typeofbutton="secoiaremove"]',
      // Matches: class="secoia_dpnd_X"
      dependencyClass: 'secoia_dpnd_',
      // Matches: data-secoia-state
      stateAttr: 'data-secoia-state',
      // Matches: data-reference="secoia"
      reference: 'secoia'
    },
    secoia2ans: {
      propPrefix: '_secoia2ans',
      // Matches: class="apl-section-cart-secoia2ans-add-remove"
      addButtonClass: '.apl-section-cart-secoia2ans-add-remove',
      // Matches: data-typeofbutton="secoia2ansremove"
      removeButtonSelector: 'cart-remove-button[data-typeofbutton="secoia2ansremove"]',
      // Matches: class="secoia2ans_dpnd_X"
      dependencyClass: 'secoia2ans_dpnd_',
      // Matches: data-secoia2ans-state
      stateAttr: 'data-secoia2ans-state',
      // Matches: data-reference="secoia2ans"
      reference: 'secoia2ans'
    }
  };

  var operationInProgress = false;

  console.log('[Secoia] Cart handlers initializing v13...');


  // UTILITY FUNCTIONS


  /**
   * Get current cart data
   */
  async function getCart() {
    return $.ajax({
      url: window.Shopify.routes.root + 'cart.js',
      type: 'GET',
      dataType: 'json'
    });
  }

  /**
   * Update cart item by line number
   */
  async function updateCartLine(line, quantity, properties) {
    return $.ajax({
      url: window.Shopify.routes.root + 'cart/change.js',
      type: 'POST',
      data: JSON.stringify({
        line: line,
        quantity: quantity,
        properties: properties
      }),
      contentType: 'application/json',
      dataType: 'json'
    });
  }

  /**
   * Update cart item by key (id) - more reliable than line-based updates
   * since line numbers can shift between sequential cart operations.
   * Matches the pattern used by gwpremove in new cart.js.
   */
  async function updateCartItemByKey(key, quantity, properties) {
    return $.ajax({
      url: window.Shopify.routes.root + 'cart/change.js',
      type: 'POST',
      data: JSON.stringify({
        id: key,
        quantity: quantity,
        properties: properties
      }),
      contentType: 'application/json',
      dataType: 'json'
    });
  }

  /**
   * Remove cart item by key
   */
  async function removeCartItem(key) {
    return $.ajax({
      type: 'POST',
      url: window.Shopify.routes.root + 'cart/change.js',
      data: { id: key, quantity: 0 },
      dataType: 'json'
    });
  }

  /**
   * Add item to cart
   */
  async function addToCart(variantId, quantity, properties) {
    return $.ajax({
      url: window.Shopify.routes.root + 'cart/add.js',
      type: 'POST',
      data: {
        id: variantId,
        quantity: quantity,
        properties: properties
      },
      dataType: 'json'
    });
  }

  /**
   * Check if item is a warranty/add-on product (not a main product)
   * Main products have _cto_product or _added_from_pdp; warranty products have *_main_product_sku
   */
  function isWarrantyProduct(item) {
    if (!item.properties) return false;
    return !!(
      item.properties._secoia_main_product_sku ||
      item.properties._secoia2ans_main_product_sku ||
      item.properties._aplcr_main_product_sku ||
      item.properties._sw_main_product_sku ||
      item.properties._gwp_main_product_sku
    );
  }

  /**
   * Copy object properties (shallow clone)
   * Preserves all properties including: _added_from_pdp, SKU, Barcode,
   * _item_token, _bundle_uuid, and all other bundle properties.
   */
  function cloneProperties(props) {
    var newProps = {};
    if (props) {
      for (var key in props) {
        if (props.hasOwnProperty(key)) {
          newProps[key] = props[key];
        }
      }
    }
    return newProps;
  }

  /**
   * Trigger cart refresh
   */
  function refreshCart(delay) {
    delay = delay || 500;
    window.setTimeout(function() {
      if (window.onCartUpdate) {
        window.onCartUpdate();
      } else {
        location.reload();
      }
    }, delay);
  }


  // CORE FUNCTIONS


  /**
   * Find parent product in cart by various identifiers
   */
  function findParentProduct(cartData, options) {
    var key = options.key;
    var sku = options.sku;
    var uuid = options.uuid;
    var handle = options.handle;
    
    for (var i = 0; i < cartData.items.length; i++) {
      var item = cartData.items[i];
      
      // Skip warranty products - we want the main product
      if (isWarrantyProduct(item)) continue;
      
      // Match by key (most reliable)
      if (key && item.key === key) {
        return { item: item, line: i + 1 };
      }
      
      // Match by UUID
      if (uuid && item.properties && item.properties._uuid === uuid) {
        return { item: item, line: i + 1 };
      }
      
      // Match by SKU
      if (sku && item.sku === sku) {
        return { item: item, line: i + 1 };
      }
      
      // Match by handle
      if (handle && item.handle === handle) {
        return { item: item, line: i + 1 };
      }
    }
    
    return null;
  }

  /**
   * Find all Secoia items for a parent product
   */
  function findSecoiaForParent(cartData, parentSku, parentUuid, type) {
    var config = CONFIG[type];
    var propPrefix = config.propPrefix;
    var results = [];
    
    for (var i = 0; i < cartData.items.length; i++) {
      var item = cartData.items[i];
      
      if (!item.properties) continue;
      
      var secoiaParentSku = item.properties[propPrefix + '_main_product_sku'];
      var secoiaUuid = item.properties._uuid;
      
      if (!secoiaParentSku) continue;
      
      var isMatch = false;
      
      // Match by SKU
      if (parentSku && secoiaParentSku === parentSku) {
        isMatch = true;
      }
      
      // Match by UUID
      if (parentUuid && secoiaUuid === parentUuid) {
        isMatch = true;
      }
      
      if (isMatch) {
        results.push({ item: item, line: i + 1 });
      }
    }
    
    return results;
  }

  /**
   * Update related warranties UUID when adding a new warranty.
   * Uses key-based updates for reliability when lines shift between operations.
   */
  async function updateRelatedWarrantiesUuid(cartData, parentSku, oldUuid, newUuid, excludeType) {
    var warrantyTypes = [
      { prop: '_aplcr_main_product_sku', name: 'AppleCare' },
      { prop: '_sw_main_product_sku', name: 'SecWarranty' },
      { prop: '_secoia_main_product_sku', name: 'Secoia' },
      { prop: '_secoia2ans_main_product_sku', name: 'Secoia2ans' },
      { prop: '_gwp_main_product_sku', name: 'GWP' }
    ];
    
    for (var i = 0; i < cartData.items.length; i++) {
      var item = cartData.items[i];
      if (!item.properties) continue;
      
      for (var j = 0; j < warrantyTypes.length; j++) {
        var wType = warrantyTypes[j];
        
        // Skip the type we're currently adding
        if (excludeType === 'secoia' && wType.prop === '_secoia_main_product_sku') continue;
        if (excludeType === 'secoia2ans' && wType.prop === '_secoia2ans_main_product_sku') continue;
        
        if (item.properties[wType.prop] === parentSku && item.properties._uuid === oldUuid) {
          console.log('[Secoia] Updating ' + wType.name + ' UUID:', item.key);
          
          var newProps = cloneProperties(item.properties);
          newProps._uuid = newUuid;
          
          // Use key-based update - more reliable than line when cart shifts
          cartData = await updateCartItemByKey(item.key, item.quantity, newProps);
          break; // Only one match per item
        }
      }
    }
    
    return cartData;
  }

  /**
   * Add Secoia warranty to cart
   * 
   * @param {Object} options - Add options from button data attributes
   * @param {string} type - 'secoia' or 'secoia2ans'
   */
  async function addSecoia(options, type) {
    var config = CONFIG[type];
    var propPrefix = config.propPrefix;
    
    console.log('[Secoia] === ADD ' + type.toUpperCase() + ' START ===');
    console.log('[Secoia] Options:', JSON.stringify(options, null, 2));
    
    try {
      var cartData = await getCart();
      
      // Find parent product
      var parent = findParentProduct(cartData, {
        key: options.parentKey,
        sku: options.parentSku,
        uuid: options.parentUuid,
        handle: options.parentHandle
      });
      
      if (!parent) {
        console.error('[Secoia] Parent product not found in cart');
        throw new Error('Parent product not found in cart');
      }
      
      var parentItem = parent.item;
      var parentLine = parent.line;
      var parentQuantity = parentItem.quantity || 1;
      
      console.log('[Secoia] Parent found:', parentItem.key);
      console.log('[Secoia] Parent Line:', parentLine);
      console.log('[Secoia] Parent Qty:', parentQuantity);
      console.log('[Secoia] Parent SKU:', parentItem.sku);
      
      // Get current UUID or create one from handle
      var currentUuid = (parentItem.properties && parentItem.properties._uuid) 
        ? parentItem.properties._uuid 
        : (options.parentUuid || options.parentHandle);
      
      console.log('[Secoia] Current UUID:', currentUuid);
      
      // Check if this type of Secoia already exists for this parent
      var existingSecoia = findSecoiaForParent(cartData, parentItem.sku, currentUuid, type);
      if (existingSecoia.length > 0) {
        console.log('[Secoia] ' + type + ' already exists for this parent, skipping add');
        return { success: true, alreadyExists: true };
      }
      
      // Build new UUID with Secoia handle
      var newUuid = currentUuid;
      if (options.secoiaHandle && !newUuid.includes(options.secoiaHandle)) {
        newUuid = newUuid + '-' + options.secoiaHandle;
      }
      
      console.log('[Secoia] New UUID:', newUuid);
      
      // STEP 1: Update parent product properties to include Secoia reference
      // cloneProperties preserves all existing props: _added_from_pdp, SKU, Barcode,
      // _item_token, _cto_product, bundle props, etc.
      var parentProps = cloneProperties(parentItem.properties);
      parentProps[propPrefix + '_sku'] = options.secoiaSku;
      parentProps[propPrefix + '_handle'] = options.secoiaHandle;
      parentProps._uuid = newUuid;
      
      console.log('[Secoia] Step 1: Updating parent with ' + type + ' reference...');
      // Use key-based update for reliability
      cartData = await updateCartItemByKey(parentItem.key, parentQuantity, parentProps);
      console.log('[Secoia] Parent updated successfully');
      
      // STEP 2: Update related warranties (AppleCare, SecWarranty, other Secoia, GWP) UUID
      console.log('[Secoia] Step 2: Updating related warranties UUID...');
      cartData = await updateRelatedWarrantiesUuid(cartData, parentItem.sku, currentUuid, newUuid, type);
      
      // STEP 3: Add Secoia product to cart
      var secoiaProps = {};
      secoiaProps[propPrefix + '_main_product_sku'] = parentItem.sku;
      secoiaProps[propPrefix + '_main_product_handle'] = options.parentHandle || parentItem.handle;
      secoiaProps[propPrefix + '_sku'] = options.secoiaSku;
      secoiaProps[propPrefix + '_handle'] = options.secoiaHandle;
      secoiaProps._uuid = newUuid;
      
      console.log('[Secoia] Step 3: Adding ' + type + ' product to cart...');
      console.log('[Secoia] Variant ID:', options.variantId);
      console.log('[Secoia] Quantity:', parentQuantity);
      console.log('[Secoia] Properties:', JSON.stringify(secoiaProps, null, 2));
      
      await addToCart(options.variantId, parentQuantity, secoiaProps);
      
      console.log('[Secoia] === ADD ' + type.toUpperCase() + ' SUCCESS ===');
      return { success: true };
      
    } catch (err) {
      console.error('[Secoia] === ADD ' + type.toUpperCase() + ' ERROR ===', err);
      throw err;
    }
  }

  /**
   * Remove Secoia properties from parent product.
   * Preserves all non-secoia properties including: _added_from_pdp, SKU, Barcode,
   * _item_token, _cto_product, and bundle properties.
   */
  async function removeSecoiaFromParent(parentSku, parentUuid, type) {
    var config = CONFIG[type];
    var propPrefix = config.propPrefix;
    
    console.log('[Secoia] Removing ' + type + ' reference from parent...');
    console.log('[Secoia] Parent SKU:', parentSku);
    console.log('[Secoia] Parent UUID:', parentUuid);
    
    try {
      var cartData = await getCart();
      
      // Find parent product that has this Secoia type
      var parentItem = null;
      var parentLine = -1;
      
      for (var i = 0; i < cartData.items.length; i++) {
        var item = cartData.items[i];
        
        // Skip warranty products
        if (isWarrantyProduct(item)) continue;
        
        // Must have the Secoia properties we're trying to remove
        if (!item.properties || !item.properties[propPrefix + '_sku']) continue;
        
        var isMatch = false;
        
        // Match by SKU
        if (parentSku && item.sku === parentSku) {
          isMatch = true;
        }
        
        // Match by UUID (check if UUID contains the base handle)
        if (parentUuid && item.properties._uuid) {
          var baseUuid = parentUuid.split('-')[0];
          if (item.properties._uuid.includes(baseUuid)) {
            isMatch = true;
          }
        }
        
        if (isMatch) {
          parentItem = item;
          parentLine = i + 1;
          console.log('[Secoia] Found parent to update:', item.key);
          break;
        }
      }
      
      if (!parentItem) {
        console.log('[Secoia] Parent not found or already updated');
        return true;
      }
      
      // Build new properties without this Secoia type
      // All other properties (_added_from_pdp, SKU, Barcode, _item_token,
      // _cto_product, bundle props) are preserved automatically
      var newProps = {};
      var secoiaHandle = parentItem.properties[propPrefix + '_handle'];
      
      for (var prop in parentItem.properties) {
        if (parentItem.properties.hasOwnProperty(prop)) {
          // Skip the Secoia properties we're removing
          if (prop === propPrefix + '_sku' || prop === propPrefix + '_handle') {
            continue;
          }
          newProps[prop] = parentItem.properties[prop];
        }
      }
      
      // Update UUID to remove Secoia handle
      if (newProps._uuid && secoiaHandle) {
        newProps._uuid = newProps._uuid.replace('-' + secoiaHandle, '');
        console.log('[Secoia] Updated UUID:', newProps._uuid);
      }
      
      console.log('[Secoia] Updating parent to remove ' + type + ' reference...');
      // Use key-based update for reliability
      await updateCartItemByKey(parentItem.key, parentItem.quantity, newProps);
      
      // Also update related warranties UUID
      var oldUuid = parentItem.properties._uuid;
      var newUuid = newProps._uuid;
      
      if (oldUuid && newUuid && oldUuid !== newUuid) {
        console.log('[Secoia] Updating related warranties with new UUID...');
        cartData = await getCart();
        await updateRelatedWarrantiesUuid(cartData, parentItem.sku, oldUuid, newUuid, type);
      }
      
      console.log('[Secoia] Parent updated successfully');
      return true;
      
    } catch (err) {
      console.error('[Secoia] Error removing ' + type + ' from parent:', err);
      return false;
    }
  }

  /**
   * Remove Secoia warranty from cart
   * 
   * @param {Object} options - Remove options from button data attributes
   * @param {string} type - 'secoia' or 'secoia2ans'
   */
  async function removeSecoia(options, type) {
    console.log('[Secoia] === REMOVE ' + type.toUpperCase() + ' START ===');
    console.log('[Secoia] Options:', JSON.stringify(options, null, 2));
    
    try {
      // Step 1: Remove Secoia item from cart
      if (options.secoiaKey) {
        console.log('[Secoia] Step 1: Removing Secoia item:', options.secoiaKey);
        await removeCartItem(options.secoiaKey);
        console.log('[Secoia] Secoia item removed');
      }
      
      // Step 2: Update parent to remove Secoia reference
      if (options.parentSku || options.parentUuid) {
        console.log('[Secoia] Step 2: Updating parent to remove reference...');
        await removeSecoiaFromParent(options.parentSku, options.parentUuid, type);
      }
      
      console.log('[Secoia] === REMOVE ' + type.toUpperCase() + ' SUCCESS ===');
      return { success: true };
      
    } catch (err) {
      console.error('[Secoia] === REMOVE ' + type.toUpperCase() + ' ERROR ===', err);
      throw err;
    }
  }

  /**
   * Remove all Secoia items when parent product is removed
   * Called from cart.js when main_product is being removed
   * 
   * @param {string} parentKey - Parent cart key
   * @param {string} parentSku - Parent SKU
   * @param {string} parentUuid - Parent UUID
   * @param {string} parentHandle - Parent handle
   */
  async function removeAllSecoiaForParent(parentKey, parentSku, parentUuid, parentHandle) {
    console.log('[Secoia] === REMOVE ALL SECOIA FOR PARENT ===');
    console.log('[Secoia] Parent key:', parentKey);
    console.log('[Secoia] Parent SKU:', parentSku);
    console.log('[Secoia] Parent UUID:', parentUuid);
    console.log('[Secoia] Parent Handle:', parentHandle);
    
    try {
      var cartData = await getCart();
      var keysToRemove = [];
      var baseUuid = parentUuid ? parentUuid.split('-')[0] : parentHandle;
      
      // Find all Secoia and Secoia2ans items for this parent
      for (var i = 0; i < cartData.items.length; i++) {
        var item = cartData.items[i];
        if (!item.properties) continue;
        
        var isSecoia = item.properties._secoia_main_product_sku === parentSku;
        var isSecoia2ans = item.properties._secoia2ans_main_product_sku === parentSku;
        
        // Also match by UUID base
        if (baseUuid && item.properties._uuid) {
          if (item.properties._uuid.includes(baseUuid)) {
            if (item.properties._secoia_main_product_sku) isSecoia = true;
            if (item.properties._secoia2ans_main_product_sku) isSecoia2ans = true;
          }
        }
        
        if (isSecoia || isSecoia2ans) {
          console.log('[Secoia] Will remove:', item.key, isSecoia ? '(secoia)' : '(secoia2ans)');
          keysToRemove.push(item.key);
        }
      }
      
      // Remove all found items
      for (var j = 0; j < keysToRemove.length; j++) {
        console.log('[Secoia] Removing item:', keysToRemove[j]);
        await removeCartItem(keysToRemove[j]);
      }
      
      console.log('[Secoia] Removed', keysToRemove.length, 'Secoia item(s)');
      return keysToRemove;
      
    } catch (err) {
      console.error('[Secoia] Error removing all for parent:', err);
      return [];
    }
  }

  /**
   * Sync Secoia quantity when parent quantity changes.
   * Uses key-based updates for reliability.
   * 
   * @param {string} parentSku - Parent SKU
   * @param {string} parentUuid - Parent UUID
   * @param {number} newQuantity - New quantity
   */
  async function syncSecoiaQuantity(parentSku, parentUuid, newQuantity) {
    console.log('[Secoia] === SYNC QUANTITY ===');
    console.log('[Secoia] Parent SKU:', parentSku);
    console.log('[Secoia] Parent UUID:', parentUuid);
    console.log('[Secoia] New quantity:', newQuantity);
    
    try {
      var cartData = await getCart();
      var baseUuid = parentUuid ? parentUuid.split('-')[0] : null;
      var updated = 0;
      
      for (var i = 0; i < cartData.items.length; i++) {
        var item = cartData.items[i];
        if (!item.properties) continue;
        
        var isSecoia = item.properties._secoia_main_product_sku === parentSku;
        var isSecoia2ans = item.properties._secoia2ans_main_product_sku === parentSku;
        
        // Also match by UUID
        if (baseUuid && item.properties._uuid && item.properties._uuid.includes(baseUuid)) {
          if (item.properties._secoia_main_product_sku) isSecoia = true;
          if (item.properties._secoia2ans_main_product_sku) isSecoia2ans = true;
        }
        
        if ((isSecoia || isSecoia2ans) && item.quantity !== newQuantity) {
          console.log('[Secoia] Syncing quantity for:', item.key, 'from', item.quantity, 'to', newQuantity);
          
          // Use key-based update - no need to recalculate line numbers
          await updateCartItemByKey(item.key, newQuantity, item.properties);
          updated++;
        }
      }
      
      console.log('[Secoia] Synced', updated, 'item(s)');
      return true;
      
    } catch (err) {
      console.error('[Secoia] Error syncing quantity:', err);
      return false;
    }
  }

  /**
   * Get Secoia cart keys for a parent by index
   * Used by cart.js for bulk cart updates
   * 
   * @param {number} index - Parent item index
   * @param {string} type - 'secoia' or 'secoia2ans' (optional, returns both if not specified)
   */
  function getSecoiaKeysForParentIndex(index, type) {
    var keys = [];
    
    if (!type || type === 'secoia') {
      var secoiaSelector = '.' + CONFIG.secoia.dependencyClass + index;
      var $secoia = $(secoiaSelector);
      if ($secoia.length) {
        $secoia.find('cart-remove-button').each(function() {
          var key = $(this).data('cartkey');
          if (key) keys.push(key);
        });
      }
    }
    
    if (!type || type === 'secoia2ans') {
      var secoia2ansSelector = '.' + CONFIG.secoia2ans.dependencyClass + index;
      var $secoia2ans = $(secoia2ansSelector);
      if ($secoia2ans.length) {
        $secoia2ans.find('cart-remove-button').each(function() {
          var key = $(this).data('cartkey');
          if (key) keys.push(key);
        });
      }
    }
    
    return keys;
  }


  // EVENT HANDLERS


  /**
   * Handle Add button click
   */
  function handleAddClick(e, type) {
    e.preventDefault();
    e.stopImmediatePropagation();
    
    var $btn = $(e.currentTarget);
    var config = CONFIG[type];
    
    console.log('[Secoia] Add button clicked for:', type);
    
    // Skip if inside cart-remove-button (it's actually a remove action)
    if ($btn.closest('cart-remove-button').length > 0) {
      console.log('[Secoia] Button inside remove button, ignoring add handler');
      return false;
    }
    
    // Check row state - if already in cart, don't add again
    var $row = $btn.closest('tr[' + config.stateAttr + ']');
    if ($row.length > 0 && $row.attr(config.stateAttr) === 'in-cart') {
      console.log('[Secoia] Row already in "in-cart" state, ignoring');
      return false;
    }
    
    // Verify the data-reference matches
    var reference = $btn.data('reference');
    if (reference && reference !== config.reference) {
      console.log('[Secoia] Wrong reference type:', reference, 'expected:', config.reference);
      return false;
    }
    
    // Prevent double-clicks
    if (operationInProgress) {
      console.log('[Secoia] Operation already in progress, ignoring');
      return false;
    }
    
    // Check if button is disabled
    if ($btn.prop('disabled') || $btn.hasClass('force-disabled')) {
      console.log('[Secoia] Button is disabled, ignoring');
      return false;
    }
    
    operationInProgress = true;
    
    // Disable buttons during operation (includes $viewCartButtons in new cart.js)
    if (window.toggleAddOnButtons) window.toggleAddOnButtons('disable');
    $btn.prop('disabled', true).addClass('force-disabled');
    
    // Gather data from button attributes (matches Liquid template)
    var options = {
      variantId: $btn.data('variantid'),           // data-variantid
      parentSku: $btn.data('skuparent'),           // data-skuparent
      parentHandle: $btn.data('handleparent'),     // data-handleparent
      parentKey: $btn.data('keyparent'),           // data-keyparent
      parentUuid: $btn.data('uuid'),               // data-uuid
      secoiaSku: $btn.data('skuaplcr'),            // data-skuaplcr (secoia sku)
      secoiaHandle: $btn.data('handleaplcr')       // data-handleaplcr (secoia handle)
    };
    
    addSecoia(options, type)
      .then(function(result) {
        operationInProgress = false;
        if (result.alreadyExists) {
          console.log('[Secoia] Already exists, just refreshing cart');
        }
        refreshCart(500);
      })
      .catch(function(err) {
        alert('Erreur lors de l\'ajout de la garantie ' + type + '. Veuillez réessayer.');
        $btn.prop('disabled', false).removeClass('force-disabled');
        operationInProgress = false;
        if (window.toggleAddOnButtons) window.toggleAddOnButtons('enable');
      });
    
    return false;
  }

  /**
   * Handle Remove button click
   */
  function handleRemoveClick(e, type) {
    e.preventDefault();
    e.stopImmediatePropagation();
    
    console.log('[Secoia] Remove button clicked for:', type);
    
    // Prevent double-clicks
    if (operationInProgress) {
      console.log('[Secoia] Operation already in progress, ignoring');
      return false;
    }
    
    operationInProgress = true;
    
    var $link = $(e.currentTarget);
    var $removeBtn = $link.closest('cart-remove-button');
    
    // Check if button is disabled
    if ($removeBtn.hasClass('force-disabled')) {
      console.log('[Secoia] Remove button is disabled, ignoring');
      operationInProgress = false;
      return false;
    }
    
    // Gather data from button attributes (matches Liquid template)
    var options = {
      secoiaKey: $removeBtn.data('cartkey'),       // data-cartkey
      parentSku: $removeBtn.data('skuparent'),     // data-skuparent
      parentUuid: $removeBtn.data('uuid')          // data-uuid
    };
    
    if (!options.secoiaKey) {
      console.error('[Secoia] No cart key found for removal');
      operationInProgress = false;
      return false;
    }
    
    // Disable buttons during operation (includes $viewCartButtons in new cart.js)
    if (window.toggleAddOnButtons) window.toggleAddOnButtons('disable');
    
    removeSecoia(options, type)
      .then(function(result) {
        operationInProgress = false;
        refreshCart(500);
      })
      .catch(function(err) {
        operationInProgress = false;
        if (window.toggleAddOnButtons) window.toggleAddOnButtons('enable');
        // Refresh anyway to show current state
        refreshCart(100);
      });
    
    return false;
  }


  // EVENT BINDING


  // Unbind any existing handlers to prevent duplicates
  $(document).off('click.secoiaAdd');
  $(document).off('click.secoiaRemove');
  $(document).off('click.secoia2ansAdd');
  $(document).off('click.secoia2ansRemove');

  // SECOIA (1 year) handlers
  // Matches: class="apl-section-cart-secoia-add-remove"
  $(document).on('click.secoiaAdd', CONFIG.secoia.addButtonClass, function(e) {
    return handleAddClick(e, 'secoia');
  });
  
  // Matches: cart-remove-button[data-typeofbutton="secoiaremove"] a
  $(document).on('click.secoiaRemove', CONFIG.secoia.removeButtonSelector + ' a', function(e) {
    return handleRemoveClick(e, 'secoia');
  });

  // SECOIA 2 ANS handlers
  // Matches: class="apl-section-cart-secoia2ans-add-remove"
  $(document).on('click.secoia2ansAdd', CONFIG.secoia2ans.addButtonClass, function(e) {
    return handleAddClick(e, 'secoia2ans');
  });
  
  // Matches: cart-remove-button[data-typeofbutton="secoia2ansremove"] a
  $(document).on('click.secoia2ansRemove', CONFIG.secoia2ans.removeButtonSelector + ' a', function(e) {
    return handleRemoveClick(e, 'secoia2ans');
  });

  // Reset operation flag on cart update
  $(document).on('cart:updated', function() {
    operationInProgress = false;
  });


  // GLOBAL API


  /**
   * Expose functions globally for cart.js integration
   */
  window.SecoiaCart = {
    // Add Secoia warranty
    add: addSecoia,
    
    // Remove Secoia warranty
    remove: removeSecoia,
    
    // Remove all Secoia for a parent (when parent is removed from cart)
    removeAllForParent: removeAllSecoiaForParent,
    
    // Sync quantity when parent qty changes
    syncQuantity: syncSecoiaQuantity,
    
    // Get cart keys for parent index (for bulk cart updates in cart.js)
    getKeysForParentIndex: getSecoiaKeysForParentIndex,
    
    // Update a cart item by key (utility, exposed for external use)
    updateByKey: updateCartItemByKey,
    
    // Configuration (for debugging)
    config: CONFIG,
    
    // Version
    version: '13'
  };

  // Legacy function names for backwards compatibility
  window.removeSecoiaForParent = removeAllSecoiaForParent;
  window.syncSecoiaQuantity = syncSecoiaQuantity;
  window.getSecoiaKeysForParent = getSecoiaKeysForParentIndex;

  console.log('[Secoia] Cart handlers initialized v13');
  console.log('[Secoia] Global API available at window.SecoiaCart');

})();